import React from 'react'
import { BlockPicker } from "react-color";

function Color({color, onColorChange}) {
  return (
    <div className='hide-mobile'>
         <span className='label'>Color</span>
            <BlockPicker
                color={color}
                onChange={(e) => onColorChange(e.hex)}
            />
    </div> 
  )
}

export default Color